import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=0855007e&scoped=true&"
import script from "./MemberInfo.vue?vue&type=script&lang=js&"
export * from "./MemberInfo.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfo.vue?vue&type=style&index=0&id=0855007e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0855007e",
  null
  
)

export default component.exports